<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DepartmentSelect',
})
</script>
<template>
  <TreeSelect
    v-model:value="valueTmp"
    v-bind="{ ...$attrs, ...(props.multiple ? multipleProps : {}) }"
    :tree-data="result"
    :field-names="{
      label: 'stationName',
      key: 'id',
      value: 'id'
    }"
    :treeLine="{ showLeafIcon: false }"
    :loading="loading"
    treeDefaultExpandAll
    showSearch
    allowClear
    treeNodeFilterProp="stationName"
    placeholder="请选择"
  />
</template>

<script lang="ts" setup name="DepartmentSelect">
import { useFetch } from '@/hooks/useFetch'
import { TreeSelect } from 'ant-design-vue'
import { API_DEPARTMENT_SIMPLE_LIST } from '@/api/department'
import { toTree } from '@bd/vue3-utils'
import { computed } from 'vue'
import { normalizeTreeValue } from '@/utils/helper'
const props = withDefaults(
  defineProps<{
    multiple?: boolean
    value?: string | string[]
  }>(),
  {
    multiple: false
  }
)
const emits = defineEmits<{
  (e: 'update:value', value: string | string[]): void
}>()
const valueTmp = computed({
  get() {
    return props.value
  },
  set(val) {
    if (props.multiple) {
      emits('update:value', normalizeTreeValue(val as any[]))
    } else {
      emits('update:value', val as string)
    }
  }
})

const multipleProps = {
  multiple: true,
  treeCheckable: true,
  showCheckedStrategy: 'SHOW_ALL',
  treeCheckStrictly: true
}
const getFn = async () => {
  const res = await API_DEPARTMENT_SIMPLE_LIST()
  return toTree({
    data: res,
    parentIdName: 'parentCode',
    sort: 'order'
  })
}
const { fetchData, result, loading } = useFetch({
  getFn,
  isShallow: true
})
fetchData()
</script>
